import { Component } from '@angular/core';
import { NavController, NavParams,LoadingController } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { Http, Response } from '@angular/http';
//types
import { Product,MyCartList,LoginInfo,ProductFilterModel } from '../model/types'

//service
import { ProductService} from '../service/product_service'
import { AppSharedService  } from '../service/app_shared';

//page
import { MenuPage } from '../menu/menu'

@Component({
  selector: 'page-proddetails',
  templateUrl: 'proddetails.html',
})
export class ProddetailsPage {

  imageUrlResources  : string;
  imageUrlLarge  : string;
  selectedProduct :Product;
  
  //constructor
  constructor(public navCtrl: NavController
    , public navParams: NavParams
    , public prodService:ProductService
    , private storage: Storage
    , public appSharedService:AppSharedService
    , private http : Http
    , private loadingCtrl : LoadingController
  ) {
    
    
    this.imageUrlResources= this.appSharedService.configInfo.applicationInfo.fileBasePath+'/Images/AppResources/';
    this.imageUrlLarge= this.appSharedService.configInfo.applicationInfo.fileBasePath+'/'+this.appSharedService.configInfo.applicationInfo.pathMediumImageUrl;
    this.selectedProduct={
      BrandName:"",
      FoodType:"",
      ProductId:0,
      Picture:"",
      ProductType:"",
      Notes:"",
      SizeList:[],
      VendorName:"",
      ProductLongDescription:"",
      ProductName:"",
      ProductShortDescription:"",
      ProductMappingList:[],
      DescriptionList:[],
      PictureList:[],
      VendorId:0
    };
    this.getProductDetails();
  }
  
  goToHome(){
    this.navCtrl.popToRoot();
    this.navCtrl.setRoot(MenuPage)
  }
  getProductDetails(){
     //get user info
     this.storage.get("bz_user_02").then((userinfo:LoginInfo) => {
      if(userinfo!=undefined && userinfo!=null && userinfo.Token!=undefined){
        var locid:number= userinfo.LocationId;
        this.getProduct(this.prodService.selectedProduct.ProductId,locid,this.prodService.selectedProduct.VendorId);
      }
    });
  }

  getProduct(productId:number,LocationId:number,VendorId:number){
    
    //create loader
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
  
    //show loader
    loading.present();

    
    var url=(this.appSharedService.configInfo.applicationInfo.apiBasePath+'/'+this.appSharedService.configInfo.urlInfo.urlGetProductDetails);
    //url=url+'/'+productId+'/'+LocationId+'/'+VendorId;
    
    let prodfiltermodel : ProductFilterModel={
      BrandId:[],
      CategoryId:[],
      keyword:"",
      LocationId:[LocationId],
      PageNumber:0,
      ProductTypeId:[],
      SubCategoryId:[],
      VendorId:[VendorId],
      ProductId:[productId]
   };

    this.http.post(url,prodfiltermodel)
    .map((data : Response) =>{
            return data.json() as Product;
        }).toPromise().then(x => {
          this.selectedProduct=x;
          loading.dismiss();        
    });
  }
  //add scroll bar

  AddFalseLoadingBar(){

    //create loader
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
  
    //show loader
    loading.present();

    setTimeout(function(){
      loading.dismiss();
    },1000);
   }
  //add to cart
  addToCart(product:Product,event:any) {
    
    this.AddFalseLoadingBar();
    
    var ddl= <HTMLSelectElement> document.getElementById('ddl_mapping_product');
    
    var mapItem = product.ProductMappingList.filter(function (el) {
                    return el.ProductMappingId== parseInt(ddl.selectedOptions[0].value)
                  })[0];
 
    var myCart: MyCartList={
      ProductMappingId:mapItem.ProductMappingId,
      ProductName:product.ProductName,
      ProductPrice:mapItem.CustomerPrice,
      ProductMinQuantity:mapItem.Product_Min_Quantity,
      ProductUnitId:mapItem.ProductUnitId,
      ProductQuantity:1,
      ProductQuantityDescription:mapItem.ProductQuantityDescription,
      ProductTotalAmount:mapItem.CustomerPrice,
      ProductId:product.ProductId,
      Picture1:product.Picture,
      VendorId:product.VendorId,
      VendorName:product.VendorName
    }
    this.utility_AddProductToCart(myCart);
  }

  // add product to cart
  utility_AddProductToCart(cartObj:MyCartList) {

    this.storage.get("bz_cart_02").then(
      (data)=>{
       if(data!=null && data!=undefined && data.length>0){
 
         let alreadyAdded = false;
         let alreadyAddedIndex = -1;
 
         for (let i = 0; i < data.length; i++){
           if(data[i].ProductMappingId == cartObj.ProductMappingId){
                 alreadyAdded = true;
                 alreadyAddedIndex = i;
                 break;
              }
         }
         //if already added then just upadte quantity
         if(alreadyAdded==true){
           data[alreadyAddedIndex].ProductQuantity = data[alreadyAddedIndex].ProductQuantity + 1;
           data[alreadyAddedIndex].ProductTotalAmount= data[alreadyAddedIndex].ProductQuantity * data[alreadyAddedIndex].ProductPrice ;

           this.storage.set('bz_cart_02', data).then(()=>{
            this.prodService.MyCarItemList=data;
            this.prodService.TotalCartLength= (data!=undefined && data !=null ?  data.length : 0);
          });
         }
         else
         {
          data.push(cartObj);
          this.storage.set('bz_cart_02', data).then(()=>{
            this.prodService.MyCarItemList=data;
            this.prodService.TotalCartLength= (data!=undefined && data !=null ?  data.length : 0);
          });
         }
       }
       else
       {
         var mylist:MyCartList[]=[];
         mylist.push(cartObj);
         this.storage.set('bz_cart_02', mylist).then(()=>{
          this.prodService.MyCarItemList=data;
          this.prodService.TotalCartLength=1;
        });
       }
    }
   );
 }

}



// WEBPACK FOOTER //
// ./src/pages/proddetails/proddetails.ts